export default {"src":"/_next/static/media/MA.4a680075.svg","height":18,"width":18};